/// <reference path="../typings/index.d.ts" />
/// <reference path="Notificacao.d.ts" />

namespace App {
    export class Notificacao implements INotificacao {
        private ajax: IAjax;
        private elMarcarTodasComoVisualizadas: JQuery = $(".marcar-todas-como-visualizada");
        private elConteudoNotificacao: JQuery = $(".conteudo-item-notificacao");
        constructor() {
            this.ajax = new App.Ajax();
            this.elMarcarTodasComoVisualizadas.on('click', (e) => { this.aoMarcarTodasComoVisualizadas(e); });
            this.elConteudoNotificacao.on('click', (e) => { this.aoMarcarNotificacaoComoLida(e); });
        }

        private aoMarcarTodasComoVisualizadas(e: JQueryEventObject) {
            this.ajax.postAcaoSemCabecalhoGlobal($(e.currentTarget).data("url-marcar-tudo-visualizada"), {}, (obj: any) => {
                $(e.currentTarget).find('.badge-notificacao').html('');
            }, {}, false);
        }
        private aoMarcarNotificacaoComoLida(e: JQueryEventObject) {
            this.ajax.postAcaoSemCabecalhoGlobal($(e.currentTarget).data("url-marcar-lida"), { id: $(e.currentTarget).data("notification-id") }, (obj: any) => {
                $(e.currentTarget).parents('a.list-group-item').addClass('opacity-05');
            }, {}, false);
        }
    }
}
